import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AvatarComponent } from '@brand-lolly/app/shared-components/avatar.component';
import { BurgerMenuComponent } from '@brand-lolly/app/sidenav/components/burger-menu/burger-menu.component';
import { IconButtonComponent } from '@brand-lolly/app/sidenav/components/icon-button.component';
import { RequestPriceButtonComponent } from '@brand-lolly/app/sidenav/components/request-price-button.component';
import { ProfileMenuComponent } from '@brand-lolly/app/sidenav/sidenav/profile-menu.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import {
	BalanceComponent,
	BurgerButtonComponent,
	ButtonComponent,
	DaysLeftComponent,
	IconComponent,
	OnOffToggleComponent,
	SkeletonLoaderComponent,
	TooltipComponent,
	TrialIndicatorPanelComponent,
	UiTextComponent,
	UpgradeButtonComponent
} from 'components';
import { AnaAssistantPanelComponent } from '../shared/ana-assistant-panel/ana-assistant-panel.component';
import { SharedModule } from '../shared/shared.module';

import { UserManagementModule } from '../user-management/user-management.module';
import { KnowledgeBaseComponent } from './component-pieces/knowledge-base/components/knowledge-base/knowledge-base.component';
import { OnboardingDialogComponent } from './components/onboarding-dialog/onboarding-dialog.component';
import { NavFilterPipe } from './sidenav/nav-filter.pipe';
import { SidenavGroupComponent } from './sidenav/sidenav-group.component';

@NgModule({
	imports: [
		SharedModule,
		TranslateModule,
		BrowserModule,
		RouterModule,
		UserManagementModule,
		TooltipComponent,
		ButtonComponent,
		UiTextComponent,
		IconButtonComponent,
		RequestPriceButtonComponent,
		TrialIndicatorPanelComponent,
		UpgradeButtonComponent,
		BalanceComponent,
		SkeletonLoaderComponent,
		ProfileMenuComponent,
		AvatarComponent,
		OnOffToggleComponent,
		IconComponent,
		BurgerMenuComponent,
		BurgerButtonComponent,
		DaysLeftComponent,
		MatTooltipModule,
		AnaAssistantPanelComponent,
		SidenavGroupComponent,
		NavFilterPipe,
		KnowledgeBaseComponent,
		OnboardingDialogComponent
	],
	providers: []
})
export class SidenavModule {}
